'use strict';

module.exports = function () {
    $(document).on('click', '.js-show-more-shades', function (e) {
        const $list = $(this).closest('.js-attribute-shades-list');
        const $firstHiddenShade = $list.find('.js-variation-selector-button:hidden').first();

        $list.addClass('full-list');
        $list.find('.js-show-more-shades').closest('.attribute-shades__item').addClass('d-none');

        if (e.detail === 0) {
            $firstHiddenShade.trigger('focus');
        }
    });

    $(document).on('click', '.shadeFilterPDP .js-tabs-nav-button', function () {
        const $allShadesList = $(this).closest('.shadeFilterPDP').find('.js-attribute-shades-list').first();

        if ($allShadesList.hasClass('full-list')) {
            $allShadesList.removeClass('full-list');
            $allShadesList.find('.js-show-more-shades').closest('.attribute-shades__item').removeClass('d-none');
        }
    });
};
